// 특이사항 게시판 관련 타입 정의

export enum NoticePriority {
  EMERGENCY = "응급",
  HIGH = "높음", 
  MEDIUM = "보통",
  LOW = "낮음"
}

export enum NoticeCategory {
  MEDICAL = "의료/건강",
  BEHAVIOR = "행동관리", 
  DAILY_CARE = "일상지원",
  EXTERNAL = "외부연계"
}

export interface Notice {
  id: number;
  target_user: string; // 이용자 이름
  note_datetime: string; // ISO 8601 형식 (YYYY-MM-DDTHH:mm:ss)
  note: string;
  remark?: string; // 선택적 필드
  priority?: NoticePriority; // 우선순위
  category?: NoticeCategory; // 카테고리
  created_at: string; // ISO 8601 형식
}

export interface CreateNoticeRequest {
  target_user: string; // 이용자 이름
  note_datetime: string;
  note: string;
  remark?: string;
  priority?: NoticePriority; // 우선순위
  category?: NoticeCategory; // 카테고리
}

export interface UpdateNoticeRequest extends CreateNoticeRequest {
  id: number;
}

export interface NoticeFilters {
  search?: string;
  target_user?: string;
  date_from?: string;
  date_to?: string;
  priority?: NoticePriority | 'ALL';
  category?: NoticeCategory | 'ALL';
}

export interface NoticePaginationResponse {
  data: Notice[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
}

// 정렬 옵션
export type NoticeSortField = 'note_datetime' | 'target_user' | 'created_at';
export type SortOrder = 'asc' | 'desc';

export interface NoticeSortOptions {
  field: NoticeSortField;
  order: SortOrder;
}